function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(3.648 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(2.2 6.386)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 53.986)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.41,79.278a5.665,5.665,0,0,1,1.669-4.093l1.2-1.2a5.094,5.094,0,0,0,0-7.195l-1.2-1.2a5.715,5.715,0,0,1,0-8.072l1.2-1.2a5.059,5.059,0,0,0,1.49-3.578V51.107a.256.256,0,0,0-.2-.249l-1.719-.377a52.975,52.975,0,0,0-22.54,0l-1.717.378a.257.257,0,0,0-.2.249v1.628a5.052,5.052,0,0,0,1.49,3.576l1.2,1.2a5.709,5.709,0,0,1,0,8.072l-1.2,1.2a5.085,5.085,0,0,0,0,7.194l1.2,1.2a5.665,5.665,0,0,1,1.669,4.093l-.62-.007a5.047,5.047,0,0,0-1.488-3.646l-1.2-1.2a5.709,5.709,0,0,1,0-8.072l1.2-1.2a5.085,5.085,0,0,0,0-7.194l-1.2-1.2a5.669,5.669,0,0,1-1.672-4.013V51.109a.88.88,0,0,1,.687-.855l1.717-.377a53.613,53.613,0,0,1,22.806,0l1.719.377a.88.88,0,0,1,.687.855v1.628a5.668,5.668,0,0,1-1.672,4.014l-1.2,1.2a5.094,5.094,0,0,0,0,7.195l1.2,1.2a5.715,5.715,0,0,1,0,8.072l-1.2,1.2a5.044,5.044,0,0,0-1.487,3.646Z",
  transform: "translate(-1.773 -48.651)",
  fill: "#373a36"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.187)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.769,24.39a9.622,9.622,0,1,1,9.622-9.622A9.634,9.634,0,0,1,14.769,24.39Zm0-18.624a9,9,0,1,0,9,9A9.012,9.012,0,0,0,14.769,5.766Z",
  transform: "translate(-5.147 -5.146)",
  fill: "#373a36"
}))), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(31.054 15.561)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M25.846,12.68a.482.482,0,1,0-.681.681h0a.479.479,0,0,0,.676,0,.471.471,0,0,0,.144-.341A.478.478,0,0,0,25.846,12.68Z",
  transform: "translate(-25.025 -12.54)",
  fill: "#373a36"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(26.536 4.575)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.523,3.828a.484.484,0,0,0,0,.68h0a.479.479,0,0,0,.676,0,.471.471,0,0,0,.144-.341.481.481,0,0,0-.823-.341Z",
  transform: "translate(-21.384 -3.687)",
  fill: "#373a36"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.575)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.69.141a.484.484,0,0,0,0,.68h0a.479.479,0,0,0,.676,0,.471.471,0,0,0,.144-.341.476.476,0,0,0-.141-.341A.482.482,0,0,0,12.69.141Z",
  transform: "translate(-12.551 0)",
  fill: "#373a36"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(26.486 26.529)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.483,21.521a.484.484,0,0,0,0,.68h0a.479.479,0,0,0,.676,0,.471.471,0,0,0,.144-.341.482.482,0,0,0-.823-.341Z",
  transform: "translate(-21.344 -21.379)",
  fill: "#373a36"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(15.499 31.054)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.629,25.166a.484.484,0,0,0,0,.68h0a.479.479,0,0,0,.676,0,.471.471,0,0,0,.144-.341.476.476,0,0,0-.141-.341A.482.482,0,0,0,12.629,25.166Z",
  transform: "translate(-12.49 -25.025)",
  fill: "#373a36"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 15.489)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.821,12.622a.479.479,0,0,0-.676,0,.479.479,0,0,0,0,.684.482.482,0,1,0,.68-.683Z",
  transform: "translate(0 -12.482)",
  fill: "#373a36"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.519 26.475)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.462,21.475a.479.479,0,0,0-.676,0,.471.471,0,0,0-.144.341.476.476,0,0,0,.141.341.481.481,0,1,0,.679-.681Z",
  transform: "translate(-3.642 -21.335)",
  fill: "#373a36"
})), /*#__PURE__*/React.createElement("g", {
  transform: "translate(4.569 4.521)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M4.5,3.783a.482.482,0,0,0-.339-.139.481.481,0,0,0-.34.821A.481.481,0,1,0,4.5,3.783Z",
  transform: "translate(-3.682 -3.644)",
  fill: "#373a36"
}))), /*#__PURE__*/React.createElement("path", {
  d: "M0,0H39V91H0Z",
  transform: "translate(-3.648 0)",
  fill: "none"
}));

var SvgGrowOutdoorIcon = function SvgGrowOutdoorIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38.997,
    height: 91,
    viewBox: "0 0 38.997 91",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrowOutdoorIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/grow-outdoor-icon.15f633b2.svg";
export { ForwardRef as ReactComponent };